<template>
  <div class="add-plan">
    <el-page-header @back="goBack" content="提现"></el-page-header>
    <div class="icon-suitcase" @click='cashLog'>
      <i class="el-icon-suitcase-1"></i>
    </div>
    <el-col :span="18" :offset="1">
      <el-form ref="form" label-width="30%">
        <el-row :gutter="20">
          <el-col :span="12" :offset="12">
            <el-form-item :label="cash">
              <span class="moneyCount">￥{{money_number_text}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="支付方式">
          <el-tag v-model="transfer_type">银行卡提现</el-tag>
        </el-form-item>

        <div>
          <el-form-item label="银行">
            <el-input placeholder="请填写开户行" v-model="bankType"></el-input>
          </el-form-item>
          <el-form-item label="户主">
            <el-input placeholder="户主" v-model="bank_account"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号">
            <el-input placeholder="银行卡号"  v-model="bankCard"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="提现金额">
          <el-input placeholder="请填写提现金额" min='0' v-model="cashFee" type="number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="addBtn" @click="addCash">提现</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </div>
</template>
<script>
import util from "@/utils";
import { addCashout, getWallet } from "@/api/index.js";
export default {
  data() {
    return {
      cashFee: "",
      changeMoney: "", //购汇价格
      bankCard: "",
      bankType: "",
      currencyType: "",
      swiftCode: "",
      currency: "",
      money_number_text: "",
      bank_account: "",
      transfer_access: "", //非银转账账户
      transfer_type: "0", //转账类型 0 银行 1 alipay 2 微信 3 PayPal
      cash: "可以提现金额："
    };
  },
  created() {
    this.getCashInfo();
  },
  methods: {
    goBack() {
      const that = this;
      // that.$router.go(-1); //返回上一层
      that.$router.push({
        path: "/index/user/wallet"
      });
    },
    /**
     * 进入日志
     */
    cashLog() {
      const that = this;
      that.$router.push({
        path: "/index/user/wallet/cashLog"
      });
    },
    addCash: function() {
      const that = this;
      if (that.transfer_type === "") {
        that.elementTips("error", "请至少选择一种付款类型");
        return;
      }
      if (that.cashFee === "" || that.cashFee <= 0) {
        that.elementTips("error", "请输入金额");
        return;
      }
      if (that.cashFee > that.money_number_text) {
        that.elementTips("error", "提现金额超出可提现金额，请重新填写");
        return;
      }

      if (that.transfer_type === "0") {
        if (that.bank_account === "") {
          that.elementTips("error", "户主不能为空");
          return;
        }
        if (that.bankType === "") {
          that.elementTips("error", "请填写银行类型");
          return;
        }
        if (that.bankCard === "") {
          that.elementTips("error", "请填写银行卡号");
          return;
        }
      }

      const params = {
        money: that.cashFee,
        token: util.getStore("user_token"),
        card: that.bankCard,
        bank: that.bankType,
        type: "￥",
        name: that.bank_account
      };
      addCashout(params).then(that.callbackHandle);
    },
    callbackHandle: function(res) {
      const that = this;
      if (res.code === 1) {
        that.elementTips("success", res.msg);
        setTimeout(function() {
          that.$router.go(-1); //返回上一层
        }, 2000);
      } else if (res.code === 1000017) {
        that.elementTips("error", res.msg);
        // that.$router.push({
        //   name: "cashLog"
        // });
      } else {
        that.elementTips("error", res.msg);
      }
    },
    /*
     *获取可提现余额
     * */
    getCashInfo: function() {
      const that = this;
      const params = {};
      getWallet(params).then(that.cashPlanHandle);
    },
    cashPlanHandle: function(res) {
      const that = this;
      const result = res;
      if (result.code === 1) {
        that.money_number_text = result.data.current_balance;
      } else {
        that.elementTips("error", res.msg);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function(type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type
      });
    }
  }
};
</script>
<style>
.myCash {
  text-align: left;
}

.moneyCount {
  margin-left: 20px;
  font-family: arial, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: #ad0707;
}

.selectBox {
  width: 100%;
}

.resStep span img {
  width: 325px;
  height: 44px;
}

.radioBtn label {
  width: 60px;
  height: 20px;
}

.radioBtn label img {
  width: 30px;
  height: 30px;
}

.addBtn {
  /* background: #04ae4e; */
  margin-top: 30px;
  width: 100%;
}

.changeMoneyContent .cashNumber {
  font-size: 18px;
  color: #ad0707;
  /* font-weight bold; */
  margin-left: 30px;
}

.changeMoneyContent .tips {
  /* background aliceblue; */
  padding: 5px;
  font-size: 12px;
  color: #9e9e9e;
}

.transfer_type {
  margin: 20px 0 40px 0;
}
.icon-suitcase{
  float: right;
  margin-top:-20px;
  margin-right: 30px;
  font-size: 25px;
  color: #00AFFF;
}
</style>
